module.exports = __webpack_public_path__ + "img/Z71_12.93c88493.jpg";